export enum VersicherungsSummeEnum {
  FUENFZEHN_MIO = '15 Mio. €',
  FUENFZIG_MIO = '50 Mio. €',
  FUENFUNDSIEBZIG_MIO = '75 Mio. €',
  HUNDERT_MIO = '100 Mio. €',
}
